import { FunctionComponent } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import { selectPlanShareUrl } from "@store/plan/planReducer";
import { useCallback } from "react";
import { addToastAction } from "@store/toastReducer";
import { useTranslation } from "react-i18next";
import { ExternalIcon } from "@icons/ExternalIcon";
import { LinkButton } from "@ui-kit/LinkButton/LinkButton";
import { selectIsKioskEnabled } from "@store/client/clientReducer";

const ShareCopyButton: FunctionComponent = () => {
  const shareUrl = useAppSelector(selectPlanShareUrl);
  const isKioskEnabled = useAppSelector(selectIsKioskEnabled);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleCopyLink = useCallback(async () => {
    await navigator.clipboard.writeText(shareUrl);
    dispatch(
      addToastAction({
        message: t("toasts.linkCopied"),
        type: "success",
      }),
    );
  }, [dispatch, shareUrl, t]);

  if (isKioskEnabled) {
    return null;
  }

  return (
    <LinkButton onPress={handleCopyLink}>
      <ExternalIcon size={18} svgName="link" />
      {t("screens.planShare.copyLink")}
    </LinkButton>
  );
};

export { ShareCopyButton };
